import axios from "axios";

function normalizeMySchedulePayload(data) {
  const payload = data?.res || data || {};

  return {
    value: Array.isArray(payload.value) ? payload.value : [],
    meta: payload.meta || null,
  };
}

export async function fetchMySchedule({ token, start, end }) {
  const response = await axios.get("/api/my-schedule", {
    params: {
      start,
      end,
    },
    headers: {
      Authorization: token,
    },
  });

  return normalizeMySchedulePayload(response.data);
}
